export const WORKSPACE_PANE_LAYOUT_DEFAULTS = {
  defaultLeftWidth: 280,
  defaultRightWidth: 360,
  minCenterWidth: 360,
  minLeftWidth: 220,
  minRightWidth: 280,
  leftResizeLabel: 'Resize left workspace pane',
  rightResizeLabel: 'Resize right workspace pane',
  resizeResetAnimationMs: 180,
  resizeHandleWidth: 8,
  resizeStep: 24,
} as const;
